import React from "react";
import Navbar from "../components/universal/navbar";
import Footer from "../components/universal/footer";
import Header from "../components/thank-you/header";
import { Helmet } from "react-helmet";
const Thankyou = () => {
  return (
    <>
      <Helmet>
        <title>Local Dentist in Ilkley, West Yorkshire - Terms of Use </title>
        <link
          rel="canonical"
          href="https://www.compositebonding-ilkley.com/thank-you"
        />
      </Helmet>
      <Navbar />
      <Header heading />
      <Footer />
    </>
  );
};

export default Thankyou;
